import CouponMethods from './Coupon';
let MethodsyPlugin = {};

MethodsyPlugin.install = function (Vue) {
    Vue.component(CouponMethods.name,CouponMethods)
}

export default MethodsyPlugin;